import { UserRole } from '../enums/user-role';
import { UserRoleKey } from '../enums/user-role-key';

const USER_ROLE_TO_KEY_MAP: Record<UserRole, UserRoleKey> = {
  [UserRole.SUPER_ADMIN]: UserRoleKey.SuperAdmin,
  [UserRole.ADMIN]: UserRoleKey.Admin,
  [UserRole.MEMBER]: UserRoleKey.Member,
};

export function mapUserRole(role: string): UserRoleKey {
  if (Object.values(UserRole).includes(role as UserRole)) {
    return USER_ROLE_TO_KEY_MAP[role as UserRole];
  }

  return UserRoleKey.Unkown;
}
